import BasePlugin from 'app/plugins/basePlugin';

class DefaultPlugin extends BasePlugin {}

DefaultPlugin.displayName = 'DefaultPlugin';

export {DefaultPlugin};



// WEBPACK FOOTER //
// ./app/plugins/defaultPlugin.jsx